<template>
  <span>
    <input v-model="location[fieldName]" type="text" class="form-control"
           :name="fullFieldName" :placeholder="i18n.t(`components.location_editor.fields.${fieldName}`)"
           @input="debouncedEmitChanged" @blur="emitChanged">
    <validation-errors v-if="error" :errors="error" />
  </span>
</template>

<script>
import debounce from 'lodash/debounce'
import ValidationErrors from '../validation-errors'

export default {
  components: {ValidationErrors},

  props: {
    fullFieldName: {
      type: String,
      required: true
    },
    fieldName: {
      type: String,
      required: true
    },
    error: {
      type: String,
      required: true
    },
    initialLocation: {
      type: Object,
      required: true
    }
  },

  emits: ['changed'],

  data() {
    return {
      location: this.initialLocation
    }
  },

  created() {
    this.debouncedEmitChanged = debounce(this.emitChanged, 100)
  },

  methods: {
    emitChanged() {
      this.$emit('changed')
    }
  }
}
</script>
